import { defineMessages } from 'react-intl'

const messages = {
    title: {
        id: 'app.components.login-page.title',
        defaultMessage: 'Login',
    },
    logo: {
        id: 'app.components.login-page.logo',
        defaultMessage: 'Logo',
    },
    loginPage: {
        id: 'app.components.login-page.login-page',
        defaultMessage: 'Login page',
    },
    enterApiKey: {
        id: 'app.components.login-page.enter-api-key',
        defaultMessage: 'Enter API Key',
    },
}

export default defineMessages(messages)
